import apiClient from './apiClient';

const saveConsent = async (consent, cookieId = null, userId = null) => {
    try {
        const payload = { consent, cookie_id: cookieId, user_id: userId };
        const response = await apiClient.post('/consent.php', payload, {
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data;
    } catch (error) {
        console.error('Errore salvataggio consenso:', error);
        throw error;
    }
};

const consentService = { saveConsent };
export default consentService;
